import React from "react";
import LayoutCuatroSquare from "./layoutCuatroSquare/LayoutCuatroSquare";
import { formatHour } from "../../../utils/utils";

const StopInfoTableSquare = ({ rows }) => {
  const formattedRows = () => {
    const formattedRows = rows.map((line) => {
      return { arrival_time: line.arrival_time, destiny: line.destiny, is_real_time: line.is_real_time, estimated_arrival_time: line.estimated_arrival_time };
    });

    return formattedRows.slice(0, 2);
  };

  const formattedRowsAndMin = () => {
    const rows = formattedRows();

    return rows.map((line) => {
      if (line.is_real_time) {
        return {
          arrival_time: line.arrival_time.replace(" min", "'"),
          destiny: line.destiny,
          _isRealTime: true,
        };
      }
      const hhmm = formatHour(line.estimated_arrival_time);
      return {
        arrival_time: "",
        destiny: `${line.destiny} - Hora aproximada: ${hhmm}`,
        _isRealTime: false,
      };
    });
  };

  return <LayoutCuatroSquare rows={formattedRowsAndMin()} />;
};

export default StopInfoTableSquare;
